import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'translations';
import TranslatedField from 'app/components/common/TranslatedField';
import TextField from 'mz-ui-kit/form/TextField';
import { SPECIAL_INSTRUCTIONS_FIELD_NAME } from 'app/constants';

import style from './style.css';

const messages = {
  specialInstructions: { id: 'BOOK_TRIP.CONTACT_INFO.SPECIAL_INSTRUCTIONS' },
};

const SpecialInstructions = ({ className, placeholder }) => (
  <TranslatedField
    className={classnames(style.container, className)}
    component={TextField}
    type="textarea"
    appearance="btp-field"
    name={SPECIAL_INSTRUCTIONS_FIELD_NAME}
    label={<FormattedMessage {...messages.specialInstructions} />}
    placeholder={placeholder}
    disableFloatingLabel
  />
);

// TODO: move to Flow types
// SpecialInstructions.propTypes = {
//   className: PropTypes.string,
//   placeholder: PropTypes.string
// };

export default SpecialInstructions;
